import { environment } from '../../../../../../environments/environment';
import { CoreStore } from '../../../../../core/store/core.store';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { hasAccessToBusinessCenter, hasAccessToCustomerPortal, hasAccessToPartnerPortal } from '@ppl/auth';

@Component({
  selector: 'ppl-top-navigation-app-switcher',
  templateUrl: './top-navigation-app-switcher.component.html',
  styleUrls: ['./top-navigation-app-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TopNavigationAppSwitcherComponent {
  crmLink = environment.crmAppUrl;
  businessCenterLink = environment.businessCenterUrl;
  customerPortalLink = environment.customerPortalUrl;
  partnerPortalLink = environment.partnerPortalUrl;

  hasAccessToCustomerPortal$ = this.store.select(hasAccessToCustomerPortal);
  hasAccessToBusinessCenter$ = this.store.select(hasAccessToBusinessCenter);
  hasAccessToPartnerPortal$ = this.store.select(hasAccessToPartnerPortal);

  constructor(
    private store: CoreStore
  ) { }
}
